










































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { FileService } from "@/services/fileService";
import ConfirmDeleteDialog from "../components/customActions/ConfirmDeleteDialog.vue";
import BackgroundSettings from "@/interfaces/studioBackground";
import { Page } from "@/interfaces/page";
import Randomstring from "randomstring";

@Component({ components: { ConfirmDeleteDialog } })
export default class ScriptManagerEditForm extends Vue {
    @Prop() dialogActive!: boolean;
    @Prop() page!: Page;
    deleteDialogActive: boolean = false;

    public backgroundsizes: string[] = [
        "contain",
        "auto",
        "cover",
        "75%",
        "50%",
        "25%",
        "10%",
    ];
    public backgroundpositions: string[] = [
        "center",
        "top left",
        "top right",
        "bottom left",
        "bottom right",
    ];
    public get backgroundSizeValue(): string {
        return this.page.backgroundSettings?.size || "contain";
    }

    public set backgroundSizeValue(newValue: string) {
        if (this.page.backgroundSettings)
            this.page.backgroundSettings.size = newValue;
    }

    public get backgroundPositionValue(): string {
        return this.page.backgroundSettings?.position || "center";
    }

    public set backgroundPositionValue(newValue: string) {
        if (this.page.backgroundSettings)
            this.page.backgroundSettings.position = newValue;
    }
    public get userlikeChatActive(): boolean {
        if (this.page.attributes.userLikeChatWidgetId) {
            return true;
        }
        return false;
    }

    public set userlikeChatActive(e: boolean) {
        if (e) {
            this.page.attributes.userLikeChatWidgetId = this.$store.state.user.userLikeChatWidgetId;
        } else {
            this.page.attributes.userLikeChatWidgetId = null;
        }
    }
    token: string = "";
    tab: null = null;

    public get showDialog(): boolean {
        return this.dialogActive;
    }
    public set showDialog(e: boolean) {
        this.done();
    }

    public uploadBackground(f: File) {
        FileService.uploadFile(Randomstring.generate(), f).then(r => {
            if (r.status == 200) {
                this.changeBackgroundSettings({
                    image: r.data.id,
                    position: this.backgroundPositionValue,
                    size: this.backgroundSizeValue,
                });
            }
        });
    }

    public changeSizeOrPosition() {
        this.changeBackgroundSettings({
            image: this.page.backgroundSettings?.image || "",
            position: this.backgroundPositionValue,
            size: this.backgroundSizeValue,
        });
    }

    public changeBackgroundSettings(backgroundSettings: BackgroundSettings) {
        this.changeBackground(backgroundSettings);
        this.page.backgroundSettings = backgroundSettings;
    }

    public async removeBackground(confirmation: boolean) {
        if (confirmation) {
            this.changeBackground(null);
            this.page.backgroundSettings = null;
        }
        this.deleteDialogActive = false;
    }

    @Emit() changeBackground(newBackground: BackgroundSettings | null) {
        return newBackground;
    }

    @Emit() done() {
        return "";
    }
}
